module.exports = __webpack_public_path__ + "img/cognitive_data_img02.8bc7a0d1.jpg";